import { Facebook, Instagram, Linkedin } from "lucide-react";

const LINKS = [
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/andreawood_mybestbodyclub", Icon: Instagram },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/andreanutrition", Icon: Facebook },
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/in/andrea-wood-b1b567269/", Icon: Linkedin },
];

export const SocialLinks = ({ className = "", variant = "dark" }) => {
  const base = variant === "dark"
    ? "bg-white/10 text-white/70 hover:bg-teal hover:text-white"
    : "bg-navy/5 text-navy hover:bg-teal hover:text-white";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {LINKS.map(({ id, label, href, Icon }) => (
        <a key={id} href={href} target="_blank" rel="noreferrer" aria-label={`MBBC on ${label}`}
          data-testid={`social-${id}`}
          className={`inline-flex items-center justify-center w-10 h-10 rounded-full transition-colors ${base}`}>
          <Icon className="w-5 h-5" />
        </a>
      ))}
    </div>
  );
};
